import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles.scss";
import {
  Button,
  ButtonIcon,
  Input,
  MenuCardNew,
  ProfileBox,
  Tag,
} from "../../../../components";
import { Spin, Tabs } from "antd";
import { v4 as uuidv4 } from "uuid";
import Pending from "./Pending/index";
import Paid from "./Paid/index";
import Rejected from "./Rejected/index";
import {
  getAdminUser,
  getOffer,
  getSessionValidateStatus,
  getUserById,
} from "../../../../api";
import { getToken, userDetails } from "../../../../utils";
import moment from "moment";

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPointWidth: 0,
      viewPointHeight: 0,
      isActiveShadow: false,
      isLoading: false,
      offerDataSource: [],
      userDataSource: [],
      pendingOffers: [],
      acceptedOffers: [],
      rejectedOffers: [],
      pendingCount: 0,
      acceptedCount: 0,
      dataForm: {
        endDate: {
          key: "endDate",
          elementType: "datePicker",
          elementConfig: {
            label: "End Date",
            size: "md",
            width: "100%",
            placeholder: "DD-MM-YYYY",
          },
          value: "",
          dateValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "End date",
        },
        startDate: {
          key: "startDate",
          elementType: "datePicker",
          elementConfig: {
            label: "End Date",
            size: "md",
            width: "100%",
            placeholder: "DD-MM-YYYY",
          },
          value: "",
          dateValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "Start date",
        },
      },
      tabJson: [
        {
          id: uuidv4(),
          key: 1,
          tabName: "Pending",
          content: <Pending />,
        },
        {
          id: uuidv4(),
          key: 2,
          tabName: "Paid",
          content: <Paid />,
        },
        {
          id: uuidv4(),
          key: 3,
          tabName: "Rejected",
          content: <Rejected />,
        },
      ],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    console.log("scrollHeight : " + scrollHeight);
    console.log("clientHeight :" + clientHeight);
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);

    let state = await userDetails();
    let sessionStatus = await getSessionValidateStatus();
    if (sessionStatus?.data?.status) {
      if (state && state.userId) {
        let res = await getUserById(state?.userId);
        console.log("getUserById", res);
        if (res && res.status) {
          const token = await getToken();
          let user = res.data;
          let data = {
            ...user,
            token: token,
          };

          this.setState({
            user: data,
            isLoading: false,
          });
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  checkValidity(value, rules) {
    let isValid = true;
    if (rules.required && !moment.isMoment(value)) {
      isValid = value && value.trim() !== "" && isValid;
    }
    return isValid;
  }

  inputHandleChange = (event, inputIdentity) => {
    let val = null;
    const updateForm = { ...this.state.dataForm };
    const updatedFormElement = {
      ...updateForm[inputIdentity],
    };
    let formatDate = "";
    if (
      inputIdentity === "startDate" ||
      inputIdentity === "endDate" ||
      inputIdentity === "validDate"
    ) {
      const parsedDate = moment(event._d, "YYYY-MM-DD");

      formatDate = parsedDate.format("YYYY-MM-DD");
    }

    switch (inputIdentity) {
      case "endDate":
        let dat_val = moment(event._d).format("YYYY-MM-DD");
        console.log("endDate", dat_val);
        //console.log("inputHandleChange", moment(event._d).format("DD-MM-YYYY"));
        updatedFormElement.value = event;
        updatedFormElement.dateValue = dat_val;
        break;
      case "startDate":
        let sdat_val = moment(event._d).format("YYYY-MM-DD");
        updatedFormElement.value = event;
        updatedFormElement.dateValue = sdat_val;
        break;
      default:
        updatedFormElement.value = event.target.value;
    }
    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation,
    );
    updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateForm, formIsValid: formIsValid });
  };

  async clearAll() {
    const updateForm = { ...this.state.dataForm };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].valid = false;
      updateForm[key].touched = false;
      if (key === "startDate" || key === "endDate" || key === "validDate") {
        updateForm[key].dateValue = "";
      }
      if (key === "startTime" || key === "endTime") {
        updateForm[key].timeValue = "";
      }
    }
    this.setState({ dataForm: updateForm });
  }

  render() {
    const { dataForm, isLoading, tabJson, user } = this.state;
    const { isPayment } = this.props;

    return (
      <>
        <div
          className={"cco__mbc-group"}
          style={{ paddingBottom: "0", paddingLeft: "0", paddingRight: "0" }}
        >
          <div
            className={"d-flex flex-row justify-content-between"}
            style={{ marginLeft: "24px", marginRight: "24px" }}
          >
            <div className={"coo__mbcg-header"}>{"Payment"}</div>
            <div>
              <Button
                text={"Select All"}
                type={"btn-edit"}
                size={"lg secondary"}
                // onClick={onClick}
              />
            </div>
          </div>
          <div
            className={"d-flex flex-row justify-content-start gap-12"}
            style={{ marginLeft: "24px", marginRight: "24px" }}
          >
            <Input
              elementConfig={dataForm.startDate.elementConfig}
              elementType={dataForm.startDate.elementType}
              required={dataForm.startDate.validation.required}
              isValid={!dataForm.startDate.valid}
              touched={dataForm.startDate.touched}
              value={dataForm.startDate.value}
              isShowRequired={false}
              size={"md"}
              margin={"mr-2"}
              label={dataForm.startDate.label}
              onChange={(event, date) => {
                this.inputHandleChange(event, dataForm.startDate.key);
              }}
            />

            <Input
              elementConfig={dataForm.endDate.elementConfig}
              elementType={dataForm.endDate.elementType}
              required={dataForm.endDate.validation.required}
              isValid={!dataForm.endDate.valid}
              touched={dataForm.endDate.touched}
              value={dataForm.endDate.value}
              isShowRequired={false}
              size={"md"}
              margin={""}
              label={dataForm.endDate.label}
              onChange={(event, date) =>
                this.inputHandleChange(event, dataForm.endDate.key)
              }
            />
          </div>
          <div className={"cco__mbcg-tab-bar"}>
            {/* <Tabs>
              {((tabJson && tabJson) || []).map((i, t) => (
                <TabPane tab={i.tabName} key={i.key}>
                  {this.state.isLoading && (
                    <div style={{ margin: "20% 50%", opacity: 0.5 }}>
                      <Spin size="large" spinning={isLoading} />
                    </div>
                  )}
                  {!this.state.isLoading && <>{i.content}</>}
                </TabPane>
              ))}
            </Tabs> */}
            <Tabs>
              <TabPane tab="Pending" key="1">
                <Pending
                  startDate={dataForm.startDate.dateValue}
                  endDate={dataForm.endDate.dateValue}
                />
              </TabPane>

              <TabPane tab="Paid" key="2">
                <Paid
                  startDate={dataForm.startDate.dateValue}
                  endDate={dataForm.endDate.dateValue}
                />
              </TabPane>

              <TabPane tab="Rejected" key="3">
                <Rejected
                  startDate={dataForm.startDate.dateValue}
                  endDate={dataForm.endDate.dateValue}
                />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isPayment: state.paymentReducer.isPayment,
    userData: state.userReducer.userData,
    refreshOffers: state.offerReducer.refreshOffers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
